import { Link } from 'react-router-dom'
import { ReactComponent as FlashIcon } from '../../../assets/svg/flash.svg'
import { RoutePaths } from 'src/routes/routePaths'
import { FF_INTERACTIVE_CENTER } from 'src/constants/feature-flags'
import { userOnboardingModalAtom } from 'src/atoms/modals/userOnboardingModal.atom'
import { useSetAtom } from 'jotai'
import { useFlag } from '@unleash/proxy-client-react'

interface OnboardingHubProgressLinkProps {
  dark?: boolean
  className?: string
  'data-testid'?: string
}

export function OnboardingHubProgressLink({
  dark = false,
  className = '',
  'data-testid': dataTestId = 'onboarding-link'
}: Readonly<OnboardingHubProgressLinkProps>) {
  const isInteractiveCenterEnabled = useFlag(FF_INTERACTIVE_CENTER)
  const setUserOnboardingModal = useSetAtom(userOnboardingModalAtom)

  const handleClick = (e: React.MouseEvent) => {
    if (!isInteractiveCenterEnabled) {
      e.preventDefault()
      setUserOnboardingModal({ isOpen: true })
    }
  }

  return (
    <Link
      to={RoutePaths.ONBOARDING_HUB}
      data-testid={dataTestId}
      className={className}
      onClick={handleClick}>
      <FlashIcon />
      <span>Next Steps</span>
    </Link>
  )
}
